import { useCallback, useContext, useEffect, useState } from "react";
import { Box, CircularProgress, Fab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { isNil } from "lodash";
import UsersTable from "./components/UsersTable/UsersTable";
import { AppContext, IAppContext } from "../../Contexts/AppContext";
import UserApi from "../../api/user";
import { User, UserRole } from "../../models/User";
import AddUserModal from "./components/AddUserModal/AddUserModal";
import { Provider as BusProvider, useBus, useListener } from "react-bus";
import DeleteUserModal from "./components/DeleteUserModal/DeleteUserModal";

export default function UsersScreen() {
	const [users, setUsers] = useState<User[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const [query, setQuery] = useState({});
	const { setTitle, userContext, snackBar, setSnackBar } = useContext(
		AppContext
	) as IAppContext;
	const bus = useBus();

	const fetchUsers = useCallback(async () => {
		if (!userContext?.permissionaryId) {
			setUsers([]);
			return;
		}

		try {
			setLoading(true);
			const accessToken = localStorage.getItem("accessToken");
			const response = await UserApi.listUsers({
				token: accessToken,
				permissionaryId: userContext.permissionaryId,
				query: JSON.stringify(query),
			});

			setUsers(response);
		} catch (error: any) {
			console.error(error);
			setSnackBar({
				open: true,
				message: "Error al obtener los usuarios",
				autoHideDuration: 6000,
				severity: "error",
				onClose: (event: React.SyntheticEvent | Event) => {
					setSnackBar({
						...snackBar,
						open: false,
					});
				},
			});
		} finally {
			setLoading(false);
		}
	}, [query, userContext]);

	useListener("reloadUsersScreenData", fetchUsers);

	useEffect(() => {
		if (!isNil(userContext)) {
			fetchUsers();
		}
	}, [fetchUsers, userContext]);

	useEffect(() => {
		setTitle("Usuarios");
	}, [setTitle]);

	return (
		<div className='justify-center content-center text-center w-full'>
			{loading ? <CircularProgress size={90} /> : <UsersTable users={users} />}
			{userContext?.role === UserRole.ADMIN ? (
				<Fab
					onClick={() => bus.emit("openAddUserModal")}
					style={{ position: "fixed", bottom: 50, right: 50 }}
					color='primary'
					aria-label='add'>
					<AddIcon />
				</Fab>
			) : null}
			<AddUserModal />
		</div>
	);
}
